module.exports = __webpack_public_path__ + "static/media/login.137781c9.jpg";